import React, { useEffect, useRef, useState } from 'react';
import { Button, Dropdown, Icon, Input } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import { observer } from 'mobx-react-lite';

interface FilterProps {
  onFiltersChange: (filters: { column: string; operator: string; value: string }[]) => void;
}

const Filter = ({onFiltersChange}:FilterProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const messageRef = useRef<HTMLDivElement>(null);
  const [filters, setFilters] = useState([{ column: '', operator: '', value: '' }]);
  const { activityStore, userStore, commonStore } = useStore();

  const dummyOptions = [
    { key: 'contains', text: 'contains', value: 'contains' },
    // { key: 'startsWith', text: 'startsWith', value: 'startsWith' },
    // { key: 'endswith', text: 'endswith', value: 'endswith' },
  ];

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event: MouseEvent) => {
    if (messageRef.current && !messageRef.current.contains(event.target as Node)) {
      setShowFilter(false);
    }
  };

  const addFilter = () => {
    setFilters([...filters, { column: '', operator: '', value: '' }]);
  };

  const tableHeads: any = localStorage.getItem('AssetTable')?.split(',');
  const transformedTableHeads: string[] = tableHeads.map((str: string) => {
    const withSpaces = str.replace(/_/g, ' ');
    return withSpaces.replace(/\b\w/g, (match: string) => match.toUpperCase());
  });

  const transformedOptions: { key: string; text: string; value: string }[] = transformedTableHeads.map(option => ({
    key: option,
    text: option,
    value: option
  }));

  const removeAllFilters = () => {
    const clearedFilters = [{ column: '', operator: '', value: '' }];
    setFilters(clearedFilters);
    onFiltersChange(clearedFilters); // Notify parent about the update
    searchFunc([], -1);
    setShowFilter(false)
  };

  const handleColumnChange = (index: any, value: any) => {
    const newFilters = [...filters];
    newFilters[index].column = value;
    setFilters(newFilters);
    onFiltersChange(newFilters);
  };

  const handleOperatorChange = (index: any, value: any) => {
    const newFilters = [...filters];
    newFilters[index].operator = value;
    setFilters(newFilters);
    onFiltersChange(newFilters);
  };

//   const searchData = async (x:any[]) => {
//     // Reset dashboard properties
//     dashboardStore.dashboard.orderData = '';
//     dashboardStore.dashboard.orderIcon = '';
//     dashboardStore.dashboard.orderName = '';
  
//     // Extract items from the object and ensure newArr is an array
//     let newArr = Array.isArray(newObj.items) ? newObj.items : [];
  
//     // Convert items to lowercase if they are strings
//     newArr = newArr.map(item => typeof item === 'string' ? item.toLowerCase() : item);
  
//     try {
//         console.log(newArr); // Log the transformed newArr
//         await activityStore.MepzLoadActivities(1, 5, newArr);
//     } catch (error) {
//         console.error('Error fetching data:', error);
//     }
//     // Do not change showFilter state here
// };

  
const searchFunc = async (data: { column: string; operator: string; value: string }[], index: number) => {
    const userId = userStore?.user!.id;
  const filterValues = data.map(filter => ({
    colName: filter.column,
    filterType: filter.operator,
    filterValue: filter.value
  }));
  // Simulate an async operation with a slight delay
  try {
    commonStore.hfcCustomerChanges ? await activityStore.HFCloadActivitiesPagination(1, userId,activityStore.HfcSelectedRow, filterValues):await activityStore.MepzLoadActivities(1, 5, filterValues);
  } catch (error) {
    console.error('Error during API call:', error);
  }
};


const handleValueChange = (index: number, value: string) => {
  const newFilters = [...filters];
  newFilters[index].value = value;
  setFilters(newFilters)
  onFiltersChange(newFilters); // Notify parent about the update
};

const ApplyFilter=()=>{
  searchFunc(filters, 0); 
  setShowFilter(false)
}


  const buttonStyle = {
    color: 'rgb(25, 118, 210)',
    backgroundColor: isHovered ? 'rgba(25, 118, 210, 0.04)' : 'white',
    border: 'none',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    marginBottom: '10px'
  };

  const handleClick = () => {
    setShowFilter(!showFilter); // Toggle the filter visibility
  };

  return (
    <div>
      <Button
        style={buttonStyle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={handleClick}
      >
        <Icon
          name="sort content ascending"
          style={{
            fontSize: '1rem',
            color: 'rgb(25, 118, 210)',
            marginLeft: '5px',
          }}
        />
        Filter
      </Button>
      {showFilter && (
        <div
          ref={messageRef}
          style={{
            marginTop: '10px',
            color: 'rgb(25, 118, 210)',
            border: '1px solid rgba(34,36,38,.15)',
            backgroundColor: 'white',
            position: 'absolute',
            padding: '10px',
            zIndex: '99',
            borderRadius: '4px',
            width: '600px'
          }}
        >
          {filters.map((_, index) => (
            <div key={index} style={{ marginBottom: '10px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{ flex: 1 }}>
                  <label htmlFor={`column-select-${index}`} style={{ display: 'block', marginBottom: '5px' }}>
                    Column
                  </label>
                  <Dropdown
                    id={`column-select-${index}`}
                    selectOnBlur={false}
                    clearable
                    placeholder="Select"
                    selection
                    options={transformedOptions}
                    style={{ flex: 1 }}
                    onChange={(e, { value }) => handleColumnChange(index, value)}
                    value={filters[index].column || ''}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label htmlFor={`option-select-${index}`} style={{ display: 'block', marginBottom: '5px' }}>
                    Operator
                  </label>
                  <Dropdown
                    id={`option-select-${index}`}selectOnBlur={false}
                    clearable
                    placeholder="Select"
                    fluid
                    selection
                    options={dummyOptions}
                    style={{ flex: 1 }}
                    onChange={(e, { value }) => handleOperatorChange(index, value)}
                    value={filters[index].operator}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label htmlFor={`input-${index}`} style={{ display: 'block', marginBottom: '5px' }}>
                    Value
                  </label>
                  <Input
                    id={`input-${index}`}
                    placeholder="Search here..."
                    style={{ flex: 2 }}
                    onChange={(e) => handleValueChange(index, e.target.value)}
                    value={filters[index].value}
                  />
                </div>
              </div>
            </div>
          ))}
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button onClick={addFilter} color="teal">Add Filter</Button>
            <div>
            <Button onClick={ApplyFilter} color="green">Apply</Button>
            <Button onClick={removeAllFilters} color="red">Remove All</Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default observer(Filter);